/* 公告弹窗样式 */
.announcement-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 110000;
  backdrop-filter: blur(8px);
  animation: announcementFadeIn 0.3s ease;
}

@keyframes announcementFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.announcement-modal-content {
  background: linear-gradient(145deg, #1a1f35, #0f1320);
  border-radius: 20px;
  width: 90%;
  max-width: 520px;
  max-height: 80vh;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(0, 170, 255, 0.3);
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.5),
    0 0 40px rgba(0, 170, 255, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  animation: announcementSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes announcementSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* 关闭按钮 */
.announcement-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.announcement-close-btn:hover {
  background: rgba(255, 77, 79, 0.2);
  border-color: rgba(255, 77, 79, 0.5);
  color: #ff4d4f;
  transform: rotate(90deg);
}

/* 头部 */
.announcement-header {
  padding: 28px 24px 20px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(0, 170, 255, 0.08) 0%, transparent 100%);
}

.announcement-icon {
  font-size: 40px;
  color: #00aaff;
  display: block;
  margin-bottom: 12px;
  animation: iconPulse 2s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.announcement-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
}

/* 加载状态 */
.announcement-loading {
  padding: 60px 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.announcement-loading i {
  font-size: 32px;
  color: #00aaff;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 空状态 */
.announcement-empty {
  padding: 60px 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.announcement-empty i {
  font-size: 48px;
  color: rgba(255, 255, 255, 0.3);
}

/* 公告列表 */
.announcement-list {
  padding: 20px;
  max-height: calc(80vh - 220px);
  overflow-y: auto;
}

.announcement-list::-webkit-scrollbar {
  width: 6px;
}

.announcement-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.announcement-list::-webkit-scrollbar-thumb {
  background: rgba(0, 170, 255, 0.3);
  border-radius: 3px;
}

.announcement-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 170, 255, 0.5);
}

/* 单条公告 */
.announcement-item {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: all 0.3s ease;
  position: relative;
}

/* 高亮的第一条公告 */
.announcement-item.highlight {
  background: linear-gradient(135deg, rgba(0, 170, 255, 0.15), rgba(0, 170, 255, 0.05));
  border: 1px solid rgba(0, 170, 255, 0.4);
  box-shadow: 0 4px 15px rgba(0, 170, 255, 0.15);
  /* overflow: hidden; */ /* 移除 overflow: hidden，防止内容被截断 */
}

.announcement-item.highlight::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #00aaff;
  box-shadow: 0 0 10px #00aaff;
  border-radius: 12px 0 0 12px; /* 添加圆角，防止超出边框 */
}

.announcement-item.highlight .announcement-item-header h3 {
  color: #ffffff;
  text-shadow: 0 0 10px rgba(0, 170, 255, 0.5);
  font-size: 1.15rem;
}

.announcement-item.highlight:hover {
  border-color: rgba(0, 170, 255, 0.6);
  box-shadow: 0 6px 20px rgba(0, 170, 255, 0.25);
  transform: translateY(-2px);
}

.announcement-item:last-child {
  margin-bottom: 0;
}

.announcement-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(0, 170, 255, 0.2);
}

.announcement-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}

.announcement-item-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #00aaff;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.announcement-item-header h3 i {
  font-size: 18px;
}

.announcement-date {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.announcement-content {
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  font-size: 0.95rem;
}

.announcement-content p {
  margin: 0 0 8px;
}

.announcement-content p:last-child {
  margin-bottom: 0;
}

/* 链接样式 - 高亮显示 */
.announcement-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #00e5ff;
  background: linear-gradient(135deg, rgba(0, 229, 255, 0.15), rgba(0, 170, 255, 0.1));
  padding: 6px 14px;
  border-radius: 20px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  border: 1px solid rgba(0, 229, 255, 0.4);
  margin: 8px 4px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 229, 255, 0.2);
  animation: linkGlow 2s ease-in-out infinite;
}

@keyframes linkGlow {
  0%, 100% {
    box-shadow: 0 2px 8px rgba(0, 229, 255, 0.2);
  }
  50% {
    box-shadow: 0 4px 20px rgba(0, 229, 255, 0.5);
  }
}

.announcement-link:hover {
  background: linear-gradient(135deg, rgba(0, 229, 255, 0.3), rgba(0, 170, 255, 0.25));
  border-color: #00e5ff;
  color: #ffffff;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 6px 25px rgba(0, 229, 255, 0.5);
  text-decoration: none;
}

.announcement-link:active {
  transform: translateY(0) scale(1);
}

/* 底部 */
.announcement-footer {
  padding: 20px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

/* 提示信息 */
.announcement-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
}

.announcement-hint i {
  font-size: 14px;
}

/* 确认按钮 */
.announcement-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 36px;
  background: linear-gradient(135deg, #00aaff, #0077cc);
  border: none;
  border-radius: 30px;
  color: #ffffff;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 170, 255, 0.4);
  min-width: 200px;
}

.announcement-confirm-btn i {
  font-size: 18px;
}

.announcement-confirm-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(0, 170, 255, 0.5);
  background: linear-gradient(135deg, #00bbff, #0088dd);
}

.announcement-confirm-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .announcement-modal-content {
    width: 95%;
    max-height: 85vh;
    border-radius: 16px;
  }

  .announcement-header {
    padding: 24px 20px 16px;
  }

  .announcement-header h2 {
    font-size: 1.3rem;
  }

  .announcement-icon {
    font-size: 32px;
  }

  .announcement-list {
    padding: 16px;
  }

  .announcement-item {
    padding: 16px;
  }

  .announcement-item-header h3 {
    font-size: 1rem;
  }

  .announcement-footer {
    padding: 16px 20px;
    gap: 10px;
  }

  .announcement-confirm-btn {
    width: 100%;
    padding: 12px 24px;
  }

  .announcement-link {
    padding: 5px 12px;
    font-size: 0.9rem;
    margin: 6px 2px;
  }
}

@media (max-width: 480px) {
  .announcement-modal-content {
    border-radius: 12px;
  }

  .announcement-close-btn {
    width: 32px;
    height: 32px;
    font-size: 18px;
    top: 12px;
    right: 12px;
  }

  .announcement-header {
    padding: 20px 16px 14px;
  }

  .announcement-header h2 {
    font-size: 1.2rem;
  }

  .announcement-list {
    padding: 14px;
    max-height: calc(85vh - 200px);
  }

  .announcement-item {
    padding: 14px;
  }

  .announcement-content {
    font-size: 0.9rem;
  }

  .announcement-footer {
    padding: 14px 16px;
  }

  .dont-show-today {
    font-size: 0.85rem;
  }

  .announcement-confirm-btn {
    padding: 10px 20px;
    font-size: 0.95rem;
  }

  .announcement-link {
    padding: 4px 10px;
    font-size: 0.85rem;
    margin: 5px 2px;
  }

  .announcement-hint {
    font-size: 0.8rem;
  }
}

/* ==========================================
   亮色主题适配 (Light Theme Adaptation)
   ========================================== */
html[data-theme='light'] .announcement-modal-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}

html[data-theme='light'] .announcement-modal-content {
  background: linear-gradient(145deg, #ffffff, #f0f4f9);
  border: 1px solid rgba(26, 115, 232, 0.2);
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.1),
    0 0 30px rgba(26, 115, 232, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

html[data-theme='light'] .announcement-close-btn {
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  color: var(--text-secondary);
}

html[data-theme='light'] .announcement-close-btn:hover {
  background: rgba(255, 77, 79, 0.1);
  border-color: rgba(255, 77, 79, 0.2);
  color: #ff4d4f;
}

html[data-theme='light'] .announcement-header {
  border-bottom: 1px solid var(--border-color);
  background: linear-gradient(180deg, rgba(26, 115, 232, 0.05) 0%, transparent 100%);
}

html[data-theme='light'] .announcement-icon {
  color: var(--accent-color);
}

html[data-theme='light'] .announcement-header h2 {
  color: var(--text-color);
}

html[data-theme='light'] .announcement-loading {
  color: var(--text-secondary);
}

html[data-theme='light'] .announcement-loading i {
  color: var(--accent-color);
}

html[data-theme='light'] .announcement-empty {
  color: var(--text-secondary);
}

html[data-theme='light'] .announcement-empty i {
  color: var(--border-color);
}

html[data-theme='light'] .announcement-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.03);
}

html[data-theme='light'] .announcement-list::-webkit-scrollbar-thumb {
  background: rgba(26, 115, 232, 0.2);
}

html[data-theme='light'] .announcement-list::-webkit-scrollbar-thumb:hover {
  background: rgba(26, 115, 232, 0.4);
}

html[data-theme='light'] .announcement-item {
  background: #ffffff;
  border: 1px solid var(--border-color);
}

html[data-theme='light'] .announcement-item:hover {
  background: #f8fafd;
  border-color: rgba(26, 115, 232, 0.2);
}

html[data-theme='light'] .announcement-item.highlight {
  background: linear-gradient(135deg, rgba(26, 115, 232, 0.08), rgba(26, 115, 232, 0.02));
  border: 1px solid rgba(26, 115, 232, 0.3);
  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.08);
}

html[data-theme='light'] .announcement-item.highlight::before {
  background: var(--accent-color);
  box-shadow: 0 0 8px var(--accent-color);
}

html[data-theme='light'] .announcement-item.highlight .announcement-item-header h3 {
  color: var(--text-color);
  text-shadow: none;
}

html[data-theme='light'] .announcement-item.highlight:hover {
  border-color: rgba(26, 115, 232, 0.5);
  box-shadow: 0 6px 20px rgba(26, 115, 232, 0.15);
}

html[data-theme='light'] .announcement-item-header h3 {
  color: var(--accent-color);
}

html[data-theme='light'] .announcement-date {
  color: var(--text-secondary);
  background: rgba(0, 0, 0, 0.05);
}

html[data-theme='light'] .announcement-content {
  color: var(--text-color);
}

html[data-theme='light'] .announcement-link {
  color: var(--accent-color);
  background: rgba(26, 115, 232, 0.06);
  border: 1px solid rgba(26, 115, 232, 0.2);
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.05);
  animation: linkGlowLight 2s ease-in-out infinite;
}

html[data-theme='light'] .announcement-link:hover {
  background: rgba(26, 115, 232, 0.12);
  border-color: var(--accent-color);
  color: var(--accent-hover);
  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.15);
}

html[data-theme='light'] .announcement-footer {
  border-top: 1px solid var(--border-color);
  background: rgba(0, 0, 0, 0.02);
}

html[data-theme='light'] .announcement-hint {
  color: var(--text-secondary);
}

html[data-theme='light'] .announcement-confirm-btn {
  background: linear-gradient(135deg, var(--accent-color), var(--accent-hover));
  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.25);
}

html[data-theme='light'] .announcement-confirm-btn:hover {
  background: linear-gradient(135deg, var(--accent-hover), #0d47a1);
  box-shadow: 0 6px 20px rgba(26, 115, 232, 0.35);
}

@keyframes linkGlowLight {
  0%, 100% {
    box-shadow: 0 2px 8px rgba(26, 115, 232, 0.08);
  }
  50% {
    box-shadow: 0 4px 15px rgba(26, 115, 232, 0.25);
  }
}

html[data-theme='light'] .announcement-modal-overlay {
  background: rgba(32,33,36,.32) !important; backdrop-filter: blur(8px) !important;
}
html[data-theme='light'] .announcement-modal-content {
  color: var(--hm-ink) !important; background: rgba(255,255,255,.98) !important;
  border: 1px solid #dce3ec !important; border-radius: 22px !important;
  box-shadow: 0 24px 64px rgba(37,55,84,.18) !important;
}
html[data-theme='light'] .announcement-header {
  color: var(--hm-ink) !important; background: #fff !important; border-color: #e7ebf1 !important;
}
html[data-theme='light'] .announcement-content,
html[data-theme='light'] .announcement-list { color: var(--hm-muted) !important; }
html[data-theme='light'] .announcement-item {
  color: var(--hm-ink) !important; background: #f8fafd !important;
  border: 1px solid #e1e7ef !important; border-radius: 14px !important; box-shadow: none !important;
}
html[data-theme='light'] .announcement-item:hover {
  background: #fff !important; border-color: #b9cde8 !important; box-shadow: var(--hm-shadow-sm) !important;
}
html[data-theme='light'] .announcement-item.highlight {
  background: #eef5ff !important; border-color: #8eb6eb !important;
  box-shadow: 0 0 0 3px rgba(26,115,232,.08) !important;
}
html[data-theme='light'] .announcement-item-header,
html[data-theme='light'] .announcement-date { color: var(--hm-ink) !important; text-shadow: none !important; }
html[data-theme='light'] .announcement-hint { color: #77818c !important; }
html[data-theme='light'] .announcement-close-btn {
  color: #6d7681 !important; background: #f3f6fa !important;
  border: 1px solid #e0e6ee !important; border-radius: 10px !important;
}
html[data-theme='light'] .announcement-confirm-btn {
  color: #fff !important; background: var(--hm-blue) !important;
  border-color: var(--hm-blue) !important; border-radius: 11px !important;
  box-shadow: 0 8px 20px rgba(26,115,232,.18) !important;
}


